import React from "react";

import async from "../components/Async";

import {
  Layout,
  Users,
  Command
} from "react-feather";

import {SchoolOutlined, DescriptionOutlined} from "@material-ui/icons";

import {NeedsLogin, NoLogin} from "./auth";

// Auth components
const SignIn = NoLogin(() => import("../pages/auth/SignIn"));
const SignUp = async(() => import("../pages/auth/SignUp"));
const ForgotPassword = async(() => import("../pages/auth/ForgotPassword"));
const ResetPassword = async(() => import("../pages/auth/ResetPassword"));

// Onboarding components
const UnifiedOnboarding = async(() => import("../pages/onboarding/UnifiedOnboarding"));

const Page404 = async(() => import("../pages/auth/Page404"));
const Page500 = async(() => import("../pages/auth/Page500"));
const TermsAndConditions = NeedsLogin(() => import("../pages/auth/TermsAndConditionsOnboarding"));
const TermsAndConditionsOnboarding = NeedsLogin(() => import("../pages/auth/TermsAndConditionsOnboarding"));

// Pages components
const Institution = NeedsLogin(() => import("../pages/pages/Reports/Institution"));
const MedicalRecords = NeedsLogin(() => import("../pages/pages/MedicalRecords/MedicalRecords"));
const Records = NeedsLogin(() => import("../pages/pages/MedicalRecords"));
const Patients = NeedsLogin(() => import("../pages/pages/Reports/Patients"));
const Reports = NeedsLogin(() => import("../pages/pages/Reports"));
const AdminPanel = NeedsLogin(() => import("../pages/pages/AdminPanel/index"));
const OnBoard = NeedsLogin(() => import("../pages/pages/OnBoard"));
const About = NeedsLogin(() => import("../pages/pages/About"));
const UserRoles = NeedsLogin(() => import("../pages/pages/UserRoles"));
const UserManual = NeedsLogin(() => import("../pages/pages/UserManual"));
const FAQs = NeedsLogin(() => import("../pages/pages/FAQs"));
const DemoEvals = NeedsLogin(() => import("../pages/pages/Reports/DemoEvals"));

//Account Routes
const MyAccount = NeedsLogin(() => import("../pages/pages/Account/MyAccount"));

//Institution Users
const InstitutionUsers = NeedsLogin(() => import("../pages/pages/Users/Users"));
const AddUser = NeedsLogin(() => import("../pages/pages/Users/addUser"));

//Register components
const AddMedicalRecord = NeedsLogin(() => import("../pages/pages/MedicalRecords/addMedicalRecord"));

// Training components
const TrainingVideosLanding = NeedsLogin(() => import("../pages/pages/Training/TrainingVideosLanding"));
const Videos = NeedsLogin(() => import("../pages/pages/Training/Videos"));
const MacAllInOneVideos = NeedsLogin(() => import("../pages/pages/Training/MacAllInOneVideos"));
const Exam = NeedsLogin(() => import("../pages/pages/Training/Exam"));
const Certificates = NeedsLogin(() => import("../pages/pages/Training/Certificates"));


const homeRoutes = {
  id: "Home",
  path: "/",
  component: OnBoard,
  children: null,
  hidden: true
};

const aboutRoutes = {
  id: "About",
  path: "/about",
  component: About,
  children: null,
  hidden: true
};

const faqsRoutes = {
  id: "FAQs",
  path: "/faqs",
  component: FAQs,
  children: null,
  hidden: true
};

const userRolesRoutes = {
  id: "User Roles",
  path: "/user_roles",
  component: UserRoles,
  children: null,
  hidden: true
};

const userManualRoutes = {
  id: "User Manual",
  path: "/user_manual",
  component: UserManual,
  children: null,
  hidden: true
};

const accountRoutes = {
  id: "My Account",
  path: "/my_account",
  component: MyAccount,
  children: null,
  hidden: true
};

const pagesRoutes = {
  id: "Institutions",
  path: "/institutions",
  icon: <Layout />,
  component: Institution,
};
{/*const medicalRecordsRoutes = {
  id: "Medical Records",
  path: "/medical_records",
  component: MedicalRecords,
  hidden: true
};*/}
const adminPanelRoutes = {
  id: "Admin Panel",
  path: "/admin_panel",
  icon: <Command />,
  component: AdminPanel,
  hidden: true
};
const usersRoutes = {
  id: "Users",
  path: "/users",
  icon: <Command />,
  component: InstitutionUsers,
  hidden: true,
  children: [
    {
      path: "/add_user",
      name: "Add user",
      component: AddUser
    },
    {
      path: "/users",
      name: "Add user",
      component: InstitutionUsers
    },
  ]
};
{/*const addMedicalRecordRoutes = {
  id: "Medical Records",
  path: "/medical_records/register",
  component: AddMedicalRecord,
  hidden: true
};*/}
const recordsRoutes = {
  id: "Records",
  path: "/medical_records/list",
  hidden: true,
  component: Records,
};

const patientsRoutes = {
  id: "Patient",
  path: "/patients",
  hidden: true,
  component: Patients,
};
const reportsRoutes = {
  id: "Reports",
  path: "/patient/reports",
  hidden: true,
  component: Reports,
};
const trainingRoutes = {
  id: "Training",
  path: "/training",
  icon: <SchoolOutlined />,
  component: TrainingVideosLanding,
  hidden: true, // Will be shown/hidden based on user roles in Sidebar.js
  children: [
    {
      path: "/training",
      name: " Training Videos",
      component: TrainingVideosLanding
    },
    {
      path: "/training/varjo",
      name: "Varjo Headset Videos",
      component: Videos,
      hidden: true
    },
    {
      path: "/training/mac-all-in-one",
      name: "MAC and All In One Videos",
      component: MacAllInOneVideos,
      hidden: true
    },
    {
      path: "/videos",
      name: " Training Videos",
      component: Videos,
      hidden: true
    },
    {
      path: "/exam",
      name: "Evaluator Exam",
      component: Exam,
      hidden: true
    },
    {
      path: "/certificates",
      name: "Certificates",
      component: Certificates
    }
  ]
};

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  hidden: true,
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn
    },
    {
      path: "/auth/sign-up",
      name: "Sign Up",
      component: SignUp
    },
    {
      path: "/auth/forgot-password",
      name: "Forgot Password",
      component: ForgotPassword
    },
    {
      path: "/reset_your_password/:id",
      name: "Reset Password",
      component: ResetPassword
    },

    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: Page500
    },
    {
      path: "/auth/terms_and_conditions",
      name: "Terms and Conditions",
      component: TermsAndConditions
    },
    {
      path: "/onboarding/terms_and_conditions",
      name: "Terms and Conditions Onboarding",
      component: TermsAndConditionsOnboarding
    },
    {
      path: "/onboarding/unified",
      name: "Unified Onboarding",
      component: UnifiedOnboarding
    }
  ]
};

const termsAndCondsRoutes = {
  id: "Terms and Conditions",
  path: "/terms_and_conditions",
  icon: <Users />,
  hidden: true,
  children: [
    {
      path: "/terms_and_conditions",
      name: "Terms and Conditions",
      component: TermsAndConditions
    }
  ]
};

const demoEvalsRoutes = {
  id: "Demo Reports",
  path: "/demo_evals",
  hidden: true,
  icon: <DescriptionOutlined />,
  component: DemoEvals,
};

export const dashboard = [
  homeRoutes,
  aboutRoutes,
  faqsRoutes,
  userManualRoutes,
  accountRoutes,
  pagesRoutes,
  //medicalRecordsRoutes,
  adminPanelRoutes,
  //addMedicalRecordRoutes,
  recordsRoutes,
  patientsRoutes,
  reportsRoutes,
  usersRoutes,
  demoEvalsRoutes,
  trainingRoutes,
  userRolesRoutes
];

export const auth = [authRoutes];
export const TandC = [termsAndCondsRoutes];

export default [
  homeRoutes,
  aboutRoutes,
  faqsRoutes,
  userManualRoutes,
  accountRoutes,
  pagesRoutes,
  //medicalRecordsRoutes,
  adminPanelRoutes,
  //addMedicalRecordRoutes,
  recordsRoutes,
  patientsRoutes,
  reportsRoutes,
  authRoutes,
  usersRoutes,
  demoEvalsRoutes,
  trainingRoutes,
  userRolesRoutes
];
